export enum SalesActivityTypeEnum {
  Note = "Note",
  StatusChange = "StatusChange",
  Assignment = "Assignment",
}
